import { useState, useEffect } from 'react'
import sortlist from 'assets/img/icon_sort.svg';
import trash from 'assets/img/trash.svg';
import styles from './styles.module.sass'

import Review from './Toggle/Review'
import HasFreeShipping from './Toggle/HasFree'
import Express from './Toggle/Express'

import HierarchicalMenu from './List/HierarchicalMenu'
import Brands from './List/Brands'
import Discounts from './List/Discounts'

import Range from './Range/Range'


const FilterSearch = (props) => {
    const {
        filters,
        initFilters,
        setFiltersActive,
        resetFilters,
        setResetFilters
    } = props

    const [ actualFilters, setActualFilters ] = useState(initFilters)
    const [ preFilters, setPreFilters ] = useState(initFilters)

    const [ reviews, setReviews ] = useState(null)
    const [ free, setFree ] = useState(null)
    const [ fullF, setFullF ] = useState(null)
    const [ categories, setCategories ] = useState([])
    const [ brands, setBrands ] = useState([])
    const [ discounts, setDiscounts ] = useState({})
    const [ rangePrice, setRangePrice ] = useState({})

    const [ singleSelCat, setSingleSelCat ] = useState(false)
    const [ singleSelBrand, setSingleSelBrand ] = useState(false)

    const [ toggleReviews, setToggleReviews ] = useState(false)
    const [ toggleFreeSipping, setToggleFreeSipping ] = useState(false)
    const [ toggleExpress, setToggleExpress ] = useState(false)
    const [ listCategories, setListCategories ] = useState([])
    const [ listBrands, setListBrands ] = useState([])
    const [ listDiscounts, setListDiscounts ] = useState({})
    const [ listRangePrice, setListRangePrice ] = useState({})

    const [ showF, setShowF ] = useState(false)
    const showFilters = () => {
        setShowF(!showF)
    }

    const deleteFilters = () => {
        setResetFilters(true)
        setShowF(false)
    }

    useEffect(()=>{
        if(filters){
            // console.log('****************')
            // console.log('init filters: ', initFilters)
            // console.log('preFilters: ', preFilters)
            // console.log('actualFilters: ', actualFilters)
            // console.log('filters in filters: ', filters)
            // console.log('****************')
            // console.log('setFree: ', filters?.hasFree?.data?.true)
            // console.log('setFullF: ', filters?.fullfilment?.data?.true)
            // console.log('setCategories: ', filters?.categories?.data)
            // console.log('setBrands: ', filters?.brands?.data)
            // console.log('setDiscounts: ', filters?.discounts?.stats)
            // console.log('setRangePrice: ', filters?.rangePrice?.lastStats)
            // console.log('****************')

            setReviews( Number( filters?.reviews?.data[4]) + Number(filters?.reviews?.data[5] ) )
            setFree(filters?.hasFree?.data?.true)
            setFullF(filters?.fullfilment?.data?.true)
            setCategories(filters?.categories?.data)
            setBrands(filters?.brands?.data)
            setDiscounts(filters?.discounts?.stats)
            setRangePrice(filters?.rangePrice?.lastStats)

            setSingleSelCat(filters?.categories?.singleSelector)
            setSingleSelBrand(filters?.brands?.singleSelector)
        }
    },[filters])

    useEffect(()=>{
        setActualFilters({
            ...actualFilters,
            reviews: toggleReviews
        })
    },[ toggleReviews ])

    useEffect(()=>{
        setActualFilters({
            ...actualFilters,
            hasFree: toggleFreeSipping
        })
    },[ toggleFreeSipping ])

    useEffect(()=>{
        setActualFilters({
            ...actualFilters,
            fullfilment: toggleExpress
        })
    },[ toggleExpress ])

    useEffect(()=>{
        setActualFilters({
            ...actualFilters,
            categories: listCategories
        })
    },[ listCategories ])

    useEffect(()=>{
        setActualFilters({
            ...actualFilters,
            brands: listBrands
        })
    },[ listBrands ])

    useEffect(()=>{
        setActualFilters({
            ...actualFilters,
            discounts: listDiscounts
        })
    },[ listDiscounts ])

    useEffect(()=>{
        setActualFilters({
            ...actualFilters,
            rangePrice: listRangePrice
        })
    },[ listRangePrice ])

    useEffect(()=>{
        if(!resetFilters){
            if( JSON.stringify(actualFilters) !== JSON.stringify(preFilters) ){
                setFiltersActive(actualFilters)
                setPreFilters(actualFilters)
            }
        }else{
            setActualFilters(initFilters)
        }
    },[ actualFilters, resetFilters ])

    const [ showBtnDelete, setShowBtnDelete ] = useState(false)
    useEffect(()=>{
        if( JSON.stringify(actualFilters) !== JSON.stringify(initFilters) ){
            setShowBtnDelete(true)
        }else{
            setShowBtnDelete(false)
        }
    },[ actualFilters, initFilters ])
    

    return(
        filters
            ?
                <div className={showF ? `${styles?.contFilters} ${styles?.active}` :styles?.contFilters}>
                    <div className={styles?.contenedorFiltros}>
                        <div className={styles?.titulo}>
                            <div onClick={showFilters} aria-hidden className={styles?.contTitleFilters}>
                                <img alt="Filtros" className={styles?.showFil} src={sortlist} />
                                <span className={styles?.h2}>Filtros</span>
                            </div>
                            {showBtnDelete
                                ?  <img alt="trash" onClick={deleteFilters} className={styles?.trash} src={trash} aria-hidden />
                                : null
                            }
                        </div>
                        <div className={styles?.filterPerDatail}>
                            {reviews
                                ? <Review resetFilters={resetFilters} setToggleReviews={setToggleReviews} />
                                : null
                            }
                            {free
                                ? <HasFreeShipping resetFilters={resetFilters} setToggleFreeSipping={setToggleFreeSipping} />
                                : null
                            }
                            {fullF
                                ? <Express resetFilters={resetFilters} setToggleExpress={setToggleExpress} />
                                : null
                            }
                            {categories[0] !== null
                                ? <HierarchicalMenu categories={categories} actualFilters={initFilters} resetFilters={resetFilters} setListCategories={setListCategories} singleSelector={singleSelCat} />
                                : null
                            }
                            {brands
                                ? <Brands brands={brands} actualFilters={initFilters} resetFilters={resetFilters} setListBrands={setListBrands} singleSelector={singleSelBrand} />
                                : null
                            }
                            
                            {discounts
                                ? <Discounts discounts={discounts} actualFilters={initFilters} resetFilters={resetFilters} setListDiscounts={setListDiscounts} />
                                : null
                            }
                            
                            {rangePrice
                                ? <Range rangePrice={rangePrice} actualFilters={initFilters} resetFilters={resetFilters} setListRangePrice={setListRangePrice} />
                                : null
                            }
                            
                        </div>
                    </div>
                </div>
            : null
    )
}


export default FilterSearch